import { Ruler } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogDescription } from './ui/dialog';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';

const TABLES = {
  femei: {
    label: 'Femei',
    head: ['Mărime', 'EU', 'Bust (cm)', 'Talie (cm)', 'Șold (cm)'],
    rows: [['XS', '34', '80–84', '62–66', '88–92'], ['S', '36', '84–88', '66–70', '92–96'],
      ['M', '38', '88–92', '70–74', '96–100'], ['L', '40', '92–96', '74–78', '100–104'],
      ['XL', '42', '96–100', '78–82', '104–108'], ['XXL', '44', '100–104', '82–86', '108–112']],
  },
  barbati: {
    label: 'Bărbați',
    head: ['Mărime', 'EU', 'Piept (cm)', 'Talie (cm)', 'Șold (cm)'],
    rows: [['XS', '44', '86–90', '74–78', '88–92'], ['S', '46', '90–94', '78–82', '92–96'],
      ['M', '48', '94–98', '82–86', '96–100'], ['L', '50', '98–102', '86–90', '100–104'],
      ['XL', '52', '102–106', '90–94', '104–108'], ['XXL', '54', '106–110', '94–98', '108–112'],
      ['3XL', '56', '110–114', '98–102', '112–116']],
  },
  incaltaminte: {
    label: 'Încălțăminte',
    head: ['EU', 'UK', 'US femei', 'US bărbați', 'Lungime talpă (cm)'],
    rows: [['35', '2.5', '5', '–', '22.4'], ['36', '3.5', '6', '4.5', '23.0'], ['37', '4', '6.5', '5', '23.7'],
      ['38', '5', '7.5', '6', '24.4'], ['39', '6', '8.5', '6.5', '25.0'], ['40', '6.5', '9', '7.5', '25.7'],
      ['41', '7.5', '10', '8', '26.4'], ['42', '8', '10.5', '8.5', '27.0'], ['43', '9', '11.5', '9.5', '27.7'],
      ['44', '9.5', '12', '10', '28.4'], ['45', '10.5', '–', '11', '29.0'], ['46', '11', '–', '12', '29.7']],
  },
};

const isShoeSize = (s) => /^\d{2}([.,]5)?$/.test(String(s || '').trim()) && Number(String(s).replace(',', '.')) >= 33;

const SizeTable = ({ id, table }) => (
  <div className="overflow-x-auto rounded-xl border border-gray-200" data-testid={`size-guide-table-${id}`}>
    <table className="w-full text-sm">
      <thead className="bg-gray-50 text-left text-xs uppercase tracking-wide text-gray-500">
        <tr>{table.head.map((h) => <th key={h} className="whitespace-nowrap px-3 py-2 font-semibold">{h}</th>)}</tr>
      </thead>
      <tbody>
        {table.rows.map((r) => (
          <tr key={r.join('-')} className="border-t border-gray-100 hover:bg-green-50/60">
            {r.map((c, i) => <td key={i} className={`whitespace-nowrap px-3 py-2 ${i === 0 ? 'font-bold text-gray-900' : 'text-gray-700'}`}>{c}</td>)}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export const SizeGuide = ({ sizes = [] }) => {
  const defaultTab = sizes.some((s) => isShoeSize(s.size)) ? 'incaltaminte' : 'femei';
  return (
    <Dialog>
      <DialogTrigger asChild>
        <button type="button" className="inline-flex items-center gap-1 text-sm font-medium text-green-700 underline-offset-4 hover:underline"
          data-testid="size-guide-open">
          <Ruler className="h-4 w-4" /> Ghid de mărimi
        </button>
      </DialogTrigger>
      <DialogContent className="max-h-[90vh] w-[calc(100vw-1.5rem)] max-w-2xl overflow-y-auto rounded-2xl p-4 sm:p-6" data-testid="size-guide-dialog">
        <DialogHeader>
          <DialogTitle>Ghid de mărimi</DialogTitle>
          <DialogDescription>
            Tabele standard UE. Măsoară-te peste lenjerie; dacă ești între două mărimi, alege-o pe cea mai mare.
            Unele branduri pot varia ușor.
          </DialogDescription>
        </DialogHeader>
        <Tabs defaultValue={defaultTab} className="min-w-0">
          <TabsList className="mb-3">
            {Object.entries(TABLES).map(([id, t]) => (
              <TabsTrigger key={id} value={id} data-testid={`size-guide-tab-${id}`}>{t.label}</TabsTrigger>
            ))}
          </TabsList>
          {Object.entries(TABLES).map(([id, t]) => (
            <TabsContent key={id} value={id}><SizeTable id={id} table={t} /></TabsContent>
          ))}
        </Tabs>
        <p className="text-xs text-gray-500">
          Încălțăminte: stai în picioare pe o foaie, marchează călcâiul și vârful celui mai lung deget și măsoară distanța.
        </p>
      </DialogContent>
    </Dialog>
  );
};
